import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminPortal } from './pages/AdminPortal';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { ForeBusinessPage } from './pages/ForeBusinessPage';
import { LandingPage } from './pages/LandingPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { PricingPage } from './pages/PricingPage';
import { useScreenInit } from './useScreenInit';
type Experience = 'customer' | 'admin' | 'fore' | 'blog' | 'blog-post' | 'pricing';
export function App() {
  const screenInit = useScreenInit() as {
    experience?: Experience;
  };
  if (screenInit.experience === 'pricing') {
    return <PricingPage data-id="element-0" data-mp="2wj8cjlweui34" />;
  }
  if (screenInit.experience === 'blog-post') {
    return <BlogPostPage data-id="element-1" data-mp="28tw972nrl48q" />;
  }
  if (screenInit.experience === 'blog') {
    return <BlogPage data-id="element-2" data-mp="23vck4tdvjcc5" />;
  }
  if (screenInit.experience === 'fore') {
    return <ForeBusinessPage data-id="element-3" data-mp="23v2rsz5cwt3a" />;
  }
  if (screenInit.experience === 'customer') {
    return <OnboardingPage data-id="element-4" data-mp="3ij668fcdfvai" />;
  }
  if (screenInit.experience === 'admin') {
    return <AdminPortal data-id="element-5" data-mp="3mkre1ma1tjdu" />;
  }
  return <BrowserRouter data-id="element-6" data-mp="3mjztd6hzp62c">
      <Routes data-id="element-7" data-mp="3mjgclt42snpw">
        <Route path="/pricing" element={<PricingPage data-id="element-9" data-mp="3rbzq6q2rjiup" />} data-id="element-8" data-mp="3rc9ca2kot5v4" />
        <Route path="/blog" element={<BlogPage data-id="element-11" data-mp="3relv0hy9rk98" />} data-id="element-10" data-mp="3rcswxr1q28cu" />
        <Route path="/blog/:slug" element={<BlogPostPage data-id="element-13" data-mp="4n6a3ahwrb3" />} data-id="element-12" data-mp="6hqtghuuhen" />
        <Route path="/fore-business" element={<ForeBusinessPage data-id="element-15" data-mp="2zlle8zeb8glo" />} data-id="element-14" data-mp="82k72sfnuax" />
        <Route path="/signup" element={<OnboardingPage data-id="element-17" data-mp="2zn6cayzu2hoa" />} data-id="element-16" data-mp="2zmenq84nlk7i" />
        <Route path="*" element={<LandingPage data-id="element-19" data-mp="33nq73vwxp979" />} data-id="element-18" data-mp="33mf0zpg0npcz" />
      </Routes>
    </BrowserRouter>;
}